<template align="center">
  <div class="animated fadeIn fadeOut text-center">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <img src="/f1/assets/img/integrate.png" class="mb-1 mr-1" width="29">
        Dashboard
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="javascript:void(0)">Integrate</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="javascript:void(0)">Dashboard</a>
        </li>
      </ul>
    </div>
    <!-- is -->
    <b-row>
    <b-col class="col-lg-3 col-md-6 col-sm-6">
        <b-card class="animated fadeIn fadeOut">
          <div class="card-body text-center">
            <img src="/f1/assets/img/dashboard/partner.png" class="mx-auto d-block" width="80">
            <p class="card-text">partner</p>
            <b-progress class="progress progress-lg" :max="model.partner.total" show-value>
              <b-progress-bar class="progress-bar bg-info" style="width:60%" :value="model.partner.enable"></b-progress-bar>
              <b-progress-bar class="progress-bar" style="width:40%" :value="model.partner.disable"></b-progress-bar>
            </b-progress>
          </div>
        </b-card>
      </b-col>
      <b-col class="col-lg-3 col-md-6 col-sm-6">
        <b-card class="animated fadeIn fadeOut">
          <div class="card-body text-center">
            <img src="/f1/assets/img/dashboard/group.png" class="mx-auto d-block" width="80">
            <p class="card-text">Group</p>
            <b-progress class="progress progress-lg" :max="model.group.total" show-value>
              <b-progress-bar class="progress-bar bg-info" style="width:60%" :value="model.group.enable"></b-progress-bar>
              <b-progress-bar class="progress-bar" style="width:40%" :value="model.group.disable"></b-progress-bar>
            </b-progress>
          </div>
        </b-card>
      </b-col>
      <b-col class="col-lg-3 col-md-6 col-sm-6">
        <b-card class="animated fadeIn fadeOut">
          <div class="card-body text-center">
            <img src="/f1/assets/img/dashboard/user.png" class="mx-auto d-block" width="80">
            <p class="card-text">User</p>
            <b-progress class="progress progress-lg" :max="model.user.total" show-value>
              <b-progress-bar class="progress-bar bg-info" style="width:60%" :value="model.user.enable"></b-progress-bar>
              <b-progress-bar class="progress-bar" style="width:40%" :value="model.user.disable"></b-progress-bar>
            </b-progress>
          </div>
        </b-card>
      </b-col>
      <b-col class="col-lg-3 col-md-6 col-sm-6">
        <b-card class="animated fadeIn fadeOut">
          <div class="card-body text-center">
            <img src="/f1/assets/img/dashboard/service.png" class="mx-auto d-block" width="80">
            <p class="card-text">Service</p>
            <b-progress class="mt-2" :max="model.subscription.total" show-value>
              <b-progress-bar v-for="(item, index) in model.subscription.list" :value="item.total" v-bind:key="index" :variant="codes.COLORS[index]"></b-progress-bar>
            </b-progress>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <vcl-facebook v-if="loading_1"></vcl-facebook>
    <b-row v-else>
      <b-col class="col-lg-12">
        <b-card class="animated fadeIn fadeOut">
          <div class="card-body text-center">
            <span class="float-right">Latest 7 day</span>
            <line-chart :data="model.login" :messages="{ empty: 'no have data' }" label="Daily User Login" :legend="true"></line-chart>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <vcl-facebook v-if="loading_2"></vcl-facebook>
    <b-row v-else>
      <b-col class="col-lg-3 col-md-6 col-sm-6">
        <b-card class="animated fadeIn fadeOut">
          <div class="card-body text-center">
            <p class="card-text">WMDS</p>
            <div class="card_number">
              {{model.wmds.summary.total}}
            </div>
            <pie-chart height="250" label="Value" class="animated fadeIn fadeOut" :donut="true" :data="[['Enable',model.wmds.summary.enable],['Disable',model.wmds.summary.disable]]" :colors="['#05c0e0', '#93d622']"></pie-chart>
          </div>
        </b-card>
      </b-col>
      <b-col class="col-lg-3 col-md-6 col-sm-6">
        <b-card class="animated fadeIn fadeOut">
          <div class="card-body text-center">
            <p class="card-text">WEBCastle</p>
            <div class="card_number">
              {{model.webcastle.summary.total}}
            </div>
            <pie-chart height="250" label="Value" class="animated fadeIn fadeOut" :donut="true" :data="[['Enable',model.webcastle.summary.enable],['Disable',model.webcastle.summary.disable]]" :colors="['#05c0e0', '#93d622']"></pie-chart>
          </div>
        </b-card>
      </b-col>
      <b-col class="col-lg-3 col-md-6 col-sm-6">
        <b-card class="animated fadeIn fadeOut">
          <div class="card-body text-center">
            <p class="card-text">WSFinder</p>
            <div class="card_number">
              {{model.wsfinder.summary.total}}
            </div>
            <pie-chart height="250" label="Value" class="animated fadeIn fadeOut" :donut="true" :data="[['Enable',model.wsfinder.summary.enable],['Disable',model.wsfinder.summary.disable]]" :colors="['#05c0e0', '#93d622']"></pie-chart>
          </div>
        </b-card>
      </b-col>
      <b-col class="col-lg-3 col-md-6 col-sm-6">
        <b-card class="animated fadeIn fadeOut">
          <div class="card-body text-center">
            <p class="card-text">WFDetector</p>
            <div class="card_number">
              {{model.forgery.summary.total}}
            </div>
            <pie-chart height="250" label="Value" class="animated fadeIn fadeOut" :donut="true" :data="[['WSFinder',model.forgery.summary.wsfinder],['WMDS',model.forgery.summary.wmds]]" :colors="['#05c0e0', '#93d622']"></pie-chart>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <vcl-facebook v-if="loading_3"></vcl-facebook>
    <b-row v-else>
      <b-col class="col-lg-3 col-md-6 col-sm-6">
        <b-card no-body class="animated fadeIn fadeOut">
          <b-card-body class="text-center">
            <img src="/f1/assets/img/dashboard/detect.png" class="mx-auto d-block" width="80">
            <p class="card-text">Detect</p>
            <div class="card_line"></div>
            <div class="card_figure">
              <span class="text-warning">{{ model.wmds.detect.dt_d || 0 }}</span>
              <span class="badge badge-pill badge-warning">
                <span v-if="model.wmds.detect.gap >= 0">+</span> {{model.wmds.detect.gap}}
              </span>
            </div>
          </b-card-body>
        </b-card>
        <b-card no-body class="animated fadeIn fadeOut">
          <b-card-body class="text-center">
            <img src="/f1/assets/img/dashboard/result.png" class="mx-auto d-block" width="80">
            <p class="card-text">Result</p>
            <div class="card_line"></div>
            <div class="card_figure">
              <span class="text-info">{{ model.wmds.result.pg_d || 0 }}</span>
              <span class="badge badge-pill badge-info">
                <span v-if="model.wmds.result.gap >= 0">+</span> {{model.wmds.result.gap}}
              </span>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <!-- webcastle -->
      <b-col class="col-lg-3 col-md-6 col-sm-6">
        <b-card no-body class="animated fadeIn fadeOut">
          <b-card-body class="text-center">
            <img src="/f1/assets/img/dashboard/detect.png" class="mx-auto d-block" width="80">
            <p class="card-text">Detect</p>
            <div class="card_line"></div>
            <div class="card_figure">
              <span class="text-warning">{{ model.webcastle.detect.dt_d || 0 }}</span>
              <span class="badge badge-pill badge-warning">
                <span v-if="model.webcastle.result.gap >= 0">+</span> {{model.webcastle.result.gap}}
              </span>
            </div>
          </b-card-body>
        </b-card>
        <b-card no-body class="animated fadeIn fadeOut">
          <b-card-body class="text-center">
            <img src="/f1/assets/img/dashboard/block.png" class="mx-auto d-block" width="80">
            <p class="card-text">Block</p>
            <div class="card_line"></div>
            <div class="card_figure">
              <span class="text-danger">{{ model.webcastle.result.pg_d || 0 }}</span>
              <span class="badge badge-pill badge-danger">
                <span v-if="model.webcastle.detect.gap >= 0">+</span> {{model.webcastle.detect.gap}}
              </span>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <!-- wsfinder -->
      <b-col class="col-lg-3 col-md-6 col-sm-6">
        <b-card no-body class="animated fadeIn fadeOut">
          <b-card-body class="text-center">
            <img src="/f1/assets/img/dashboard/detect.png" class="mx-auto d-block" width="80">
            <p class="card-text">Detect</p>
            <div class="card_line"></div>
            <div class="card_figure">
              <span class="text-warning">{{ model.wsfinder.detect.dt_d || 0 }}</span>
              <span class="badge badge-pill badge-warning">
                <span v-if="model.wsfinder.detect.gap >= 0">+</span> {{model.wsfinder.detect.gap}}
              </span>
            </div>
          </b-card-body>
        </b-card>
        <b-card no-body class="animated fadeIn fadeOut">
          <b-card-body class="text-center">
            <img src="/f1/assets/img/dashboard/result.png" class="mx-auto d-block" width="80">
            <p class="card-text">Result</p>
            <div class="card_line"></div>
            <div class="card_figure">
              <span class="text-info">{{ model.wsfinder.result.pg_d || 0 }}</span>
              <span class="badge badge-pill badge-info">
                <span v-if="model.wsfinder.result.gap >= 0">+</span> {{model.wsfinder.result.gap}}
              </span>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <!-- wfdetect -->
      <b-col class="col-lg-3 col-md-6 col-sm-6">
        <b-card no-body class="animated fadeIn fadeOut">
          <b-card-body class="text-center">
            <img src="/f1/assets/img/dashboard/wsfinder.png" class="mx-auto d-block" width="80">
            <p class="card-text">WSFinder</p>
            <div class="card_line"></div>
            <div class="card_figure">
              <span class="text-warning">{{ model.forgery.wsfinder.pg_d || 0 }}</span>
              <span class="badge badge-pill badge-warning">
                <span v-if="model.forgery.wsfinder.gap >= 0">+</span> {{model.forgery.wsfinder.gap}}
              </span>
            </div>
          </b-card-body>
        </b-card>
        <b-card no-body class="animated fadeIn fadeOut">
          <b-card-body class="text-center">
            <img src="/f1/assets/img/dashboard/wmds.png" class="mx-auto d-block" width="80">
            <p class="card-text">WMDS</p>
            <div class="card_line"></div>
            <div class="card_figure">
              <span class="text-warning">{{ model.forgery.wmds.pg_d || 0 }}</span>
              <span class="badge badge-pill badge-warning">
                <span v-if="model.forgery.wmds.gap >= 0">+</span> {{model.forgery.wmds.gap}}
              </span>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <router-view ></router-view>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>